import { Col } from 'components/grid'
import React from 'react'

interface Props {
	name: string
	logo: string
	text: string
	arcAdventures?: boolean
}

export default function DigitalSolutionsProductBox({ name, logo, text, arcAdventures }: Props) {
	return (
		<Col width="w-full lg:w-1/2" className="mb-6">
			<div className="h-full rounded border bg-white p-6 shadow">
				<div className="flex items-center justify-center" style={{ minHeight: 110 }}>
					<img src={logo} alt={`${name} logo`} style={{ maxHeight: 80 }} />
				</div>
				<p>{text}</p>
				{arcAdventures && (
					<div className="flex justify-center mt-3">
						<a href="https://apps.apple.com/us/app/arc-adventures/id1238821192" target="_blank" rel="noopener noreferrer" className="mr-2">
							<img src="/images/core-adoption/app-store-logo.png" alt="app store logo" style={{ maxHeight: 50 }} />
						</a>
						<a
							href="https://play.google.com/store/apps/details?id=com.americanreading.arcadventure&hl=en_US&gl=US"
							target="_blank"
							rel="noopener noreferrer"
							className="ml-2"
						>
							<img src="/images/core-adoption/play-store-logo.png" alt="app store logo" style={{ maxHeight: 50 }} />
						</a>
					</div>
				)}
			</div>
		</Col>
	)
}
